import React from "react";
import { Link, Redirect } from "react-router-dom";
import Joi from "joi-browser";
import Form from "../../components/common/form";
import auth from "../../services/authService";
import BrandingLogo from "../../components/common/BrandingLogo";
import BrandingAppTitle from "../../components/common/BrandingAppTitle";
import { appVersion } from "../../config";
import { toast } from "react-toastify";

class LoginForm extends Form {
  state = {
    data: { 
      username: "",
      password: "" 
    },
    errors: {}
  };

  schema = {
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password")
  };

  componentDidMount() {
    const params = new URLSearchParams(location.search);
    const error = params.get('error');
    if (error) {
      toast.error(decodeURIComponent(error));
    }
  }

  doSubmit = async () => {
    try {
      const { data } = this.state;
      await auth.login(data.username, data.password);
      toast.success("Login successful");

      const { state } = this.props.location;
      window.location = "/client/home";
    } catch (ex) {
      const errors = { ...this.state.errors };
      let errorMessage = "Login failed. Please check your credentials and try again.";
      if (ex.response && ex.response.data) {
        if (typeof ex.response.data === "string") {
          errorMessage = ex.response.data;
        } else if (ex.response.data.error) {
          errorMessage = ex.response.data.error;
        }
      } else if (ex.message) {
        errorMessage = ex.message;
      }
      errors.username = errorMessage;
      this.setState({ errors });
      toast.error(errorMessage);
    }
  };

  render() {
    if (auth.getCurrentUser()) return <Redirect to="/home" />;

    const { data, errors } = this.state;

    return (
      <React.Fragment>
        <div className="d-flex flex-column justify-content-center align-items-center min-vh-100">
          <form 
            className="form-signin border border-light rounded shadow mb-3"
            onSubmit={this.handleSubmit}
          >
            <BrandingLogo className="mx-auto d-block mb-2" maxHeight="45px" />
            <p className="text-muted text-center small m-3">
              Client Portal
            </p>
            <hr className="mb-5" />

            {this.renderFloatingInput("username", "Username", "text", "username")}

            {this.renderFloatingInput("password", "Password", "password", "current-password")}

            <div className="d-flex justify-content-end mb-3">
              <Link className="small text-muted" to="/forgot-password">Forgot password?</Link>
            </div>

            {this.renderButton("Login", <i className="fa fa-sign-in" />, "block")}
          </form>
          <p className="text-muted text-center small">
            © {new Date().getFullYear()} <BrandingAppTitle /> {appVersion && <span>v{appVersion}</span>}
          </p>
        </div>
      </React.Fragment>
    );
  }
}

export default LoginForm;
